import { RootState } from '@reducers';

export const selectHealthQuoteResultPage = (state: RootState) => state.healthQuoteResultPageReducer;
